import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, CardHeader, Collapse } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import MetaTags from 'react-meta-tags';
import { useAuth } from '../../store/auth';
import { termsContent } from "../../data";
import { termsContentArabic } from "../../data/indexArabic";

const PageTerms = () => {
    const { isArabic } = useAuth();
    const data = isArabic ? termsContent : termsContentArabic;
    const [openAccordion, setOpenAccordion] = useState(null);

    const toggleAccordion = (index) => {
        setOpenAccordion(openAccordion === index ? null : index);
    };

    useEffect(() => {
        const scrollNavigation = () => {
            const topnav = document.getElementById("topnav");
            if (topnav) {
                if (window.scrollY > 80) {
                    topnav.classList.add("nav-sticky");
                } else {
                    topnav.classList.remove("nav-sticky");
                }
            }
        };
        window.addEventListener("scroll", scrollNavigation);
        return () => {
            window.removeEventListener("scroll", scrollNavigation);
        };
    }, []);

    return (
        <React.Fragment>
            <MetaTags>
                <title>Terms & Conditions | Subul Contracting</title>
            </MetaTags>

            <section className="bg-half-170 bg-light d-table w-100">
                <Container>
                    <Row className="mt-5 justify-content-center">
                        <Col lg={12} className="text-center">
                            <div className="pages-heading">
                                <h1 className="title mb-0">{data?.title}</h1>
                            </div>
                        </Col>
                    </Row>
                    <div className="position-breadcrumb">
                        <nav aria-label="breadcrumb" className="d-inline-block">
                            <ul className="breadcrumb rounded shadow mb-0 px-4 py-2">
                                {data?.breadcrumb?.map((item, index) => (
                                    <li className={item?.className} key={index}>
                                        {item?.link ? <Link to={item.link}>{item.name}</Link> : item?.name}
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </Container>
            </section>

            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={9}>
                            <Card className="shadow-sm border-0 rounded-3">
                                <CardBody className="p-4 p-md-5">
                                    <h5 className="card-title">{data?.welcome?.title}</h5>
                                    <p className="text-muted">{data?.welcome?.content}</p>

                                    <h5 className="card-title mt-4">{data?.commitment?.title}</h5>
                                    <p className="text-muted">{data?.commitment?.content}</p>

                                    <h5 className="card-title mt-4">{data?.restrictions?.title}</h5>
                                    <p className="text-muted">{data?.restrictions?.content}</p>
                                    <ul className="list-unstyled feature-list text-muted mt-3">
                                        {data?.restrictions?.listItems?.map((item, index) => (
                                            <li key={index} className="d-flex align-items-center mb-2">
                                                <FeatherIcon icon="arrow-right" className="fea icon-sm me-2" />
                                                <span>{item}</span>
                                            </li>
                                        ))}
                                    </ul>

                                    <h5 className="card-title mt-4">{data?.faq?.title}</h5>
                                    <div className="accordion mt-4" id="accordionExample">
                                        {data?.faq?.faqItems?.map((faqItem, index) => {
                                            const isOpen = openAccordion === index;
                                            return (
                                                <Card key={index} className="border-0 rounded-3 shadow-sm mb-2 overflow-hidden">
                                                    <Link
                                                        to="#"
                                                        onClick={(e) => { e.preventDefault(); toggleAccordion(index); }}
                                                        className={`faq d-block position-relative ${isOpen ? "text-primary" : "text-dark"}`}
                                                    >
                                                        <CardHeader className="border-0 bg-light p-3" id={`heading${index}`}>
                                                            <h6 className="title mb-0 d-flex justify-content-between align-items-center">
                                                                {faqItem?.question}
                                                                <i className={`mdi ${isOpen ? "mdi-chevron-up" : "mdi-chevron-down"}`}></i>
                                                            </h6>
                                                        </CardHeader>
                                                    </Link>
                                                    <Collapse isOpen={isOpen}>
                                                        <CardBody>
                                                            <p className="text-muted mb-0 faq-ans">{faqItem?.answer}</p>
                                                        </CardBody>
                                                    </Collapse>
                                                </Card>
                                            );
                                        })}
                                    </div>
                                    <div className="mt-4">
                                        {data?.buttons.map((button, index) => (
                                            <Link key={index} to={button.to} className={`${button.className} rounded-pill me-2`}>
                                                {button.label}
                                            </Link>
                                        ))}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default PageTerms;